import api from "./api.js";

const notificationService = {
  /**
   * Fetch paginated notifications for the current user.
   * @param {Object} params - { page, limit, unreadOnly, type }
   */
  getNotifications: async (params = {}) => {
    const { page = 1, limit = 20, unreadOnly = false, type = null } = params;
    const query = new URLSearchParams({ page, limit, unreadOnly });
    if (type) query.set("type", type);
    const response = await api.get(`/notifications?${query.toString()}`);
    return response.data;
  },

  /**
   * Mark a single notification as read.
   * @param {string} id - Notification ID
   */
  markAsRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  },

  /**
   * Mark all notifications as read for the current user.
   */
  markAllAsRead: async () => {
    const response = await api.put("/notifications/read-all");
    return response.data;
  },

  /**
   * Delete a single notification.
   * @param {string} id - Notification ID
   */
  deleteNotification: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },

  /**
   * Delete all notifications for the current user.
   */
  deleteAllNotifications: async () => {
    const response = await api.delete("/notifications");
    return response.data;
  },
};

export default notificationService;
